import registrations from './registrations'
import utilities from './utilities'
import resources from './resources'

const backendLib = {
  ...registrations,
  ...utilities,
  ...resources
}

export default backendLib
